import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
import $ from '../../utils/ajax';
function get_dedup_rank(_x) {
  return _get_dedup_rank.apply(this, arguments);
}
function _get_dedup_rank() {
  _get_dedup_rank = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", $.getJSON("/v1/rate/get_dedup_rank/", params));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _get_dedup_rank.apply(this, arguments);
}
function get_deduplicate(_x2) {
  return _get_deduplicate.apply(this, arguments);
}
function _get_deduplicate() {
  _get_deduplicate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", $.getJSON("/v1/rate/get_deduplicate/", params));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _get_deduplicate.apply(this, arguments);
}
function get_compress_rank(_x3) {
  return _get_compress_rank.apply(this, arguments);
}
function _get_compress_rank() {
  _get_compress_rank = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", $.getJSON("/v1/rate/get_compress_rank/", params));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _get_compress_rank.apply(this, arguments);
}
function get_compress(_x4) {
  return _get_compress.apply(this, arguments);
}
function _get_compress() {
  _get_compress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", $.getJSON("/v1/rate/get_compress/", params));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _get_compress.apply(this, arguments);
}
function get_system(_x5) {
  return _get_system.apply(this, arguments);
}
function _get_system() {
  _get_system = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", $.getJSON("/v1/rate/get_system/", params));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _get_system.apply(this, arguments);
}
function get_wans(_x6) {
  return _get_wans.apply(this, arguments);
}
function _get_wans() {
  _get_wans = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", $.getJSON("/v1/rate/get_wans/", params, false));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _get_wans.apply(this, arguments);
}
function get_session_ct(_x7) {
  return _get_session_ct.apply(this, arguments);
}
function _get_session_ct() {
  _get_session_ct = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", $.getJSON("/v1/rate/get_session_ct/", params, false));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _get_session_ct.apply(this, arguments);
}
function get_tunnel_agent(_x8) {
  return _get_tunnel_agent.apply(this, arguments);
}
function _get_tunnel_agent() {
  _get_tunnel_agent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", $.getJSON("/v1/rate/get_tunnel_agent/", params, false));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _get_tunnel_agent.apply(this, arguments);
}
function get_multi_band(_x9) {
  return _get_multi_band.apply(this, arguments);
}
function _get_multi_band() {
  _get_multi_band = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", $.getJSON("/v1/rate/get_multi_band/", params, false));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _get_multi_band.apply(this, arguments);
}
function get_4g_flow(_x10) {
  return _get_4g_flow.apply(this, arguments);
}
function _get_4g_flow() {
  _get_4g_flow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", $.post("/v1/rate/get_4g_flow/", params));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _get_4g_flow.apply(this, arguments);
}
function get_days4g(_x11) {
  return _get_days4g.apply(this, arguments);
}
function _get_days4g() {
  _get_days4g = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", $.getJSON("/v1/rate/get_days4g/", params));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _get_days4g.apply(this, arguments);
}
function get_interface(_x12) {
  return _get_interface.apply(this, arguments);
}
function _get_interface() {
  _get_interface = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", $.getJSON("/v1/rate/get_interface/", params));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _get_interface.apply(this, arguments);
}
function get_band_load_all(_x13) {
  return _get_band_load_all.apply(this, arguments);
}
function _get_band_load_all() {
  _get_band_load_all = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", $.getJSON("/v1/rate/get_band_load_all/", params));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _get_band_load_all.apply(this, arguments);
}
function get_band_load(_x14) {
  return _get_band_load.apply(this, arguments);
}
function _get_band_load() {
  _get_band_load = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(params) {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", $.getJSON("/v1/rate/get_band_load/", params));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _get_band_load.apply(this, arguments);
}
function get_rtt_data(_x15) {
  return _get_rtt_data.apply(this, arguments);
}
function _get_rtt_data() {
  _get_rtt_data = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(params) {
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", $.getJSON("/v1/step/statistics/", params));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _get_rtt_data.apply(this, arguments);
}
function statistics(_x16) {
  return _statistics.apply(this, arguments);
}
function _statistics() {
  _statistics = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", $.getJSON("/v1/step/statistics/", params, false));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _statistics.apply(this, arguments);
}
function getStatistics(_x17) {
  return _getStatistics.apply(this, arguments);
}
function _getStatistics() {
  _getStatistics = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(params) {
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", $.getJSON("/v1/step/statistics/", params));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _getStatistics.apply(this, arguments);
}
function update_app_name(_x18) {
  return _update_app_name.apply(this, arguments);
}
function _update_app_name() {
  _update_app_name = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(params) {
    var formData, key;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          formData = new FormData();
          for (key in params) {
            formData.append(key, params[key]);
          }
          return _context18.abrupt("return", $.formPost("/v1/rate/update_app_name/", formData));
        case 3:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _update_app_name.apply(this, arguments);
}
function get_srcip_list(_x19) {
  return _get_srcip_list.apply(this, arguments);
}
function _get_srcip_list() {
  _get_srcip_list = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(params) {
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", $.getJSON("/v1/rate/get_srcip_list/", params));
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _get_srcip_list.apply(this, arguments);
}
function get_steps_beta(_x20) {
  return _get_steps_beta.apply(this, arguments);
}
function _get_steps_beta() {
  _get_steps_beta = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(params) {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", $.getJSON("/v1/rate/get_steps_beta/", params));
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _get_steps_beta.apply(this, arguments);
}
function get_step_class(_x21) {
  return _get_step_class.apply(this, arguments);
}
function _get_step_class() {
  _get_step_class = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(params) {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", $.getJSON("/v1/rate/get_step_class/", params));
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _get_step_class.apply(this, arguments);
}
function get_step_apps(_x22) {
  return _get_step_apps.apply(this, arguments);
}
function _get_step_apps() {
  _get_step_apps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(params) {
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", $.getJSON("/v1/rate/get_step_apps/", params));
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _get_step_apps.apply(this, arguments);
}
function get_users_dpi(_x23) {
  return _get_users_dpi.apply(this, arguments);
}
function _get_users_dpi() {
  _get_users_dpi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(params) {
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", $.getJSON("/v1/rate/get_users_dpi/", params));
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _get_users_dpi.apply(this, arguments);
}
function get_users_dpi_search(_x24) {
  return _get_users_dpi_search.apply(this, arguments);
}
function _get_users_dpi_search() {
  _get_users_dpi_search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(params) {
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", $.getJSON("/v1/rate/get_user_dpi/", params));
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _get_users_dpi_search.apply(this, arguments);
}
function get_dpi_days(_x25) {
  return _get_dpi_days.apply(this, arguments);
}
function _get_dpi_days() {
  _get_dpi_days = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(params) {
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", $.getJSON("/v1/rate/get_dpi_days/", params));
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _get_dpi_days.apply(this, arguments);
}
function get_step_apps_search(_x26) {
  return _get_step_apps_search.apply(this, arguments);
}
function _get_step_apps_search() {
  _get_step_apps_search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(params) {
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", $.getJSON("/v1/rate/get_step_apps_search/", params));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _get_step_apps_search.apply(this, arguments);
}
function get_steps_search(_x27) {
  return _get_steps_search.apply(this, arguments);
}
function _get_steps_search() {
  _get_steps_search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(params) {
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", $.getJSON("/v1/rate/get_step_search/", params));
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _get_steps_search.apply(this, arguments);
}
function get_main_flow(_x28) {
  return _get_main_flow.apply(this, arguments);
}
function _get_main_flow() {
  _get_main_flow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(params) {
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", $.getJSON("/v1/rate/get_main_flow/", params));
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _get_main_flow.apply(this, arguments);
}
function get_dpi_dstrank(_x29) {
  return _get_dpi_dstrank.apply(this, arguments);
}
function _get_dpi_dstrank() {
  _get_dpi_dstrank = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(params) {
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", $.getJSON("/v1/rate/get_dpi_dstrank/", params));
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _get_dpi_dstrank.apply(this, arguments);
}
function get_dpi_dstflow(_x30) {
  return _get_dpi_dstflow.apply(this, arguments);
}
function _get_dpi_dstflow() {
  _get_dpi_dstflow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(params) {
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", $.getJSON("/v1/rate/get_dpi_dstflow/", params));
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _get_dpi_dstflow.apply(this, arguments);
}
function get_path_rtt(_x31) {
  return _get_path_rtt.apply(this, arguments);
}
function _get_path_rtt() {
  _get_path_rtt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(params) {
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", $.getJSON("/v1/rate/get_path_rtt/", params));
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _get_path_rtt.apply(this, arguments);
}
function get_path_miss(_x32) {
  return _get_path_miss.apply(this, arguments);
}
function _get_path_miss() {
  _get_path_miss = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(params) {
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", $.getJSON("/v1/rate/get_path_miss/", params));
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _get_path_miss.apply(this, arguments);
}
function get_line_top(_x33) {
  return _get_line_top.apply(this, arguments);
}
function _get_line_top() {
  _get_line_top = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(params) {
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          return _context33.abrupt("return", $.getJSON("/v1/rate/get_line_top/", params));
        case 1:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _get_line_top.apply(this, arguments);
}
function get_line_detail(_x34) {
  return _get_line_detail.apply(this, arguments);
}
function _get_line_detail() {
  _get_line_detail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(params) {
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", $.getJSON("/v1/rate/get_line_detail/", params));
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _get_line_detail.apply(this, arguments);
}
function get_line_tunnel(_x35) {
  return _get_line_tunnel.apply(this, arguments);
}
function _get_line_tunnel() {
  _get_line_tunnel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(params) {
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", $.getJSON("/v1/rate/get_line_tunnel/", params));
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _get_line_tunnel.apply(this, arguments);
}
function get_path_seg(_x36) {
  return _get_path_seg.apply(this, arguments);
}
function _get_path_seg() {
  _get_path_seg = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(params) {
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          return _context36.abrupt("return", $.getJSON("/v1/rate/get_path_seg/", params));
        case 1:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _get_path_seg.apply(this, arguments);
}
function get_cmp_month_flow(_x37) {
  return _get_cmp_month_flow.apply(this, arguments);
}
function _get_cmp_month_flow() {
  _get_cmp_month_flow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(params) {
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.abrupt("return", $.getJSON("/v1/rate/get_cmp_month_4g/", params));
        case 1:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _get_cmp_month_flow.apply(this, arguments);
}
function get_steps_month_flow(_x38) {
  return _get_steps_month_flow.apply(this, arguments);
}
function _get_steps_month_flow() {
  _get_steps_month_flow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(params) {
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          return _context38.abrupt("return", $.getJSON("/v1/rate/get_steps_month_4g/", params));
        case 1:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _get_steps_month_flow.apply(this, arguments);
}
function get_dpi_ctclass(_x39) {
  return _get_dpi_ctclass.apply(this, arguments);
}
function _get_dpi_ctclass() {
  _get_dpi_ctclass = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(params) {
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          return _context39.abrupt("return", $.getJSON("/v1/rate/get_dpi_ctclass/", params));
        case 1:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _get_dpi_ctclass.apply(this, arguments);
}
function get_tunnel_ctrank(_x40) {
  return _get_tunnel_ctrank.apply(this, arguments);
}
function _get_tunnel_ctrank() {
  _get_tunnel_ctrank = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(params) {
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          return _context40.abrupt("return", $.getJSON("/v1/rate/get_tunnel_ctrank/", params));
        case 1:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return _get_tunnel_ctrank.apply(this, arguments);
}
function get_dpi_classrank(_x41) {
  return _get_dpi_classrank.apply(this, arguments);
}
function _get_dpi_classrank() {
  _get_dpi_classrank = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41(params) {
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          return _context41.abrupt("return", $.getJSON("/v1/rate/get_dpi_classrank/", params));
        case 1:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return _get_dpi_classrank.apply(this, arguments);
}
function get_dpi_tuplerank(_x42) {
  return _get_dpi_tuplerank.apply(this, arguments);
}
function _get_dpi_tuplerank() {
  _get_dpi_tuplerank = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42(params) {
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          return _context42.abrupt("return", $.getJSON("/v1/rate/get_dpi_tuplerank/", params));
        case 1:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return _get_dpi_tuplerank.apply(this, arguments);
}
function get_4g_strength_latest(_x43) {
  return _get_4g_strength_latest.apply(this, arguments);
}
function _get_4g_strength_latest() {
  _get_4g_strength_latest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43(params) {
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          return _context43.abrupt("return", $.getJSON("/v1/rate/get_4g_strength_latest/", params));
        case 1:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return _get_4g_strength_latest.apply(this, arguments);
}
function get_4g_strength_line(_x44) {
  return _get_4g_strength_line.apply(this, arguments);
}
function _get_4g_strength_line() {
  _get_4g_strength_line = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44(params) {
    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", $.getJSON("/v1/rate/get_4g_strength_line/", params));
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _get_4g_strength_line.apply(this, arguments);
}
function get_tunnel_property(_x45) {
  return _get_tunnel_property.apply(this, arguments);
}
function _get_tunnel_property() {
  _get_tunnel_property = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(params) {
    return _regeneratorRuntime().wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          return _context45.abrupt("return", $.getJSON("/v1/rate/get_tunnel_property/", params));
        case 1:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return _get_tunnel_property.apply(this, arguments);
}
function get_internet_property(_x46) {
  return _get_internet_property.apply(this, arguments);
}
function _get_internet_property() {
  _get_internet_property = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46(params) {
    return _regeneratorRuntime().wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          return _context46.abrupt("return", $.getJSON("/v1/rate/get_internet_property/", params));
        case 1:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return _get_internet_property.apply(this, arguments);
}
function corporate_info(_x47) {
  return _corporate_info.apply(this, arguments);
}
function _corporate_info() {
  _corporate_info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47(params) {
    return _regeneratorRuntime().wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          return _context47.abrupt("return", $.put("/falcon/api/v1/boss/corporate/info", params));
        case 1:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return _corporate_info.apply(this, arguments);
}
function get_real_working_path(_x48) {
  return _get_real_working_path.apply(this, arguments);
}
function _get_real_working_path() {
  _get_real_working_path = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48(params) {
    return _regeneratorRuntime().wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          return _context48.abrupt("return", $.getJSON("/v1/rate/get_real_working_path/", params));
        case 1:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return _get_real_working_path.apply(this, arguments);
}
export { get_steps_month_flow, get_cmp_month_flow, get_path_seg, get_line_tunnel, get_line_detail, get_line_top, get_dpi_dstflow, get_dpi_dstrank, get_main_flow, get_steps_search, get_users_dpi_search, get_step_apps_search, get_dpi_days, get_users_dpi, get_step_class, get_step_apps, get_steps_beta, getStatistics, get_srcip_list, update_app_name, statistics, get_rtt_data, get_4g_flow, get_multi_band, get_band_load, get_band_load_all, get_days4g, get_interface, get_system, get_wans, get_session_ct, get_tunnel_agent, get_dedup_rank, get_deduplicate, get_compress, get_compress_rank, get_path_rtt, get_path_miss, get_dpi_ctclass, get_tunnel_ctrank, get_dpi_classrank, get_dpi_tuplerank, get_4g_strength_latest, get_4g_strength_line, get_tunnel_property, get_internet_property, corporate_info, get_real_working_path };